import { render, staticRenderFns } from "./positivesalon-video-new-player.vue?vue&type=template&id=4c475150&scoped=true&"
import script from "./positivesalon-video-new-player.vue?vue&type=script&lang=js&"
export * from "./positivesalon-video-new-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c475150",
  null
  
)

export default component.exports